export enum TemplateLabelsIds {
  SubleaseRep = 187,
  SubLessor = 188,
  ListingRep = 202,
  TenantAgentRep = 215,
  ListingRepDisplayName = 203,
}

/*
 * Sublease Rep, Sub Lessor and Listing Rep need to get data based on role_desc
 * as like in static condensed view. SubleaseRep and SubLessor do not have
 * specific column ids and column info to get company name based on respective
 * role desc. Listing Rep has column id but the column info role dec also has
 * `Sub lease Representative` along with `Listing Representative` So, Created
 * below constant to get these fields data based on role_desc as like static
 * availability condensed view
 */
export function getCompanyFieldsInfo(labelId: number) {
  const argumentsInfo = {
    [TemplateLabelsIds.SubleaseRep]: {
      field: 'company_contact_role_addresses/company_name',
      path: `company_contact_role_addresses[role_desc='Sub lease Representative'].company_name`,
      condition: `'role_desc'='Sub lease Representative'`,
    },
    [TemplateLabelsIds.SubLessor]: {
      field: 'company_contact_role_addresses/company_name',
      path: `company_contact_role_addresses[role_desc='Sub Lessor' ].company_name`,
      condition: `'role_desc'='Sub Lessor'`,
    },
    [TemplateLabelsIds.ListingRep]: {
      path: `company_contact_role_addresses[role_desc='Listing Representative' ].company_name`,
      condition: `'role_desc'='Listing Representative'`,
    },
    [TemplateLabelsIds.TenantAgentRep]: {
      path: `company_contact_role_addresses[role_desc='Tenant Representative' ].contact_display_name`,
      condition: `'role_desc'='Tenant Representative'`,
    },
    [TemplateLabelsIds.ListingRepDisplayName]: {
      path: `company_contact_role_addresses[role_desc='Listing Representative' ].contact_display_name`,
      condition: `'role_desc'='Listing Representative'`,
    },
  };
  return argumentsInfo[labelId];
}

export enum Country {
  NewZealand = 'New Zealand',
}
